import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';
import { useState } from 'react';
import { PhoneNumberContent } from './PhoneNumberContent/PhoneNumberContent';
import { OtpContent } from './OtpContent/OtpContent';

interface ModalLoginPhoneNumberProps {
  onClose: () => void;
  isOpen: boolean;
}
export interface Credential {
  phone?: string;
  session?: string;
}

export const ModalLogin = ({ isOpen, onClose }: ModalLoginPhoneNumberProps) => {
  const [credential, setCredential] = useState<Credential>({});

  // TO DO: Refactor
  const handleCredentialChange = (data: Credential) => {
    if (data.phone === undefined || data.session === undefined) return;
    setCredential(data);
  };

  const handleSessionRefresh = (session: string) => {
    setCredential((prevState) => ({
      ...prevState,
      session,
    }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior='inside' motionPreset='slideInBottom'>
      <ModalOverlay />
      <ModalContent textAlign='right' maxH='calc(100dvh - 24px)' mx={3}>
        {credential.session && credential.phone ? (
          <OtpContent
            onClose={onClose}
            credential={credential}
            onSessionRefresh={handleSessionRefresh}
            onBackToPhoneStep={() => setCredential({})}
          />
        ) : (
          <PhoneNumberContent
            isLoginModalOpen={isOpen}
            onChangeCredential={handleCredentialChange}
          />
        )}
      </ModalContent>
    </Modal>
  );
};
